import {
  SEGMENT_FIELD_TYPES,
  SEGMENT_TYPES,
  clone,
} from "./registry/segmentRegistryCore";
import structureSegments from "./registry/structureSegments";
import commerceSegments from "./registry/commerceSegments";
import contentSegments from "./registry/contentSegments";
import closingSegments from "./registry/closingSegments";

const registry = {
  ...structureSegments,
  ...commerceSegments,
  ...contentSegments,
  ...closingSegments,
};

export { SEGMENT_FIELD_TYPES, SEGMENT_TYPES };

function deepFreeze(value) {
  if (!value || typeof value !== "object" || Object.isFrozen(value)) return value;
  Object.freeze(value);
  Object.values(value).forEach(deepFreeze);
  return value;
}

export const SEGMENT_REGISTRY = deepFreeze(registry);
export const SEGMENT_ORDER = Object.freeze([
  SEGMENT_TYPES.NAVBAR,
  SEGMENT_TYPES.HERO,
  SEGMENT_TYPES.SPOTLIGHT,
  SEGMENT_TYPES.FEATURED,
  SEGMENT_TYPES.BRANDS,
  SEGMENT_TYPES.CATEGORIES,
  SEGMENT_TYPES.ABOUT,
  SEGMENT_TYPES.HIGHLIGHTS,
  SEGMENT_TYPES.CONTACT,
  SEGMENT_TYPES.FOOTER,
  SEGMENT_TYPES.FLOATING_WHATSAPP,
]);

export function getSegmentDefinition(segmentType) {
  return SEGMENT_REGISTRY[segmentType] || null;
}


export function buildSegmentVisibilityChanges(segmentType, nextVisible) {
  const definition = getSegmentDefinition(segmentType);
  const visibilityPath = definition?.visibilityPath;
  if (!visibilityPath) return {};

  const visible = nextVisible === true;
  const changes = { [visibilityPath]: visible };

  (definition.properties || [])
    .filter(
      (property) =>
        property.type === SEGMENT_FIELD_TYPES.BOOLEAN &&
        /\.enabled$/.test(property.path || "")
    )
    .forEach((property) => {
      changes[property.path] = visible;
    });

  if (definition.requiresProducts && visible) {
    changes["sections.showProducts"] = true;
  }

  return changes;
}

export function getSegmentEditableProperties(segmentType) {
  return getSegmentDefinition(segmentType)?.properties || [];
}

export function getSegmentDefaultValues(segmentType) {
  const definition = getSegmentDefinition(segmentType);
  if (!definition) return {};
  return definition.properties.reduce((defaults, property) => {
    if (property.key === "visualStyle") {
      defaults.visualStyle = clone(property.defaultValue);
      return defaults;
    }
    defaults[property.path] = clone(property.defaultValue);
    return defaults;
  }, {});
}

export function isKnownSegmentType(segmentType) {
  return Object.prototype.hasOwnProperty.call(SEGMENT_REGISTRY, segmentType);
}

export default SEGMENT_REGISTRY;
